import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgEdit = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 28,
	height: 28,
	viewBox: "0 0 28 28",
	fill: "none",
	stroke: "#846701",
	xmlns: "http://www.w3.org/2000/svg",
	"aria-hidden": "true",
	focusable: "false",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		id: "PencilSimpleLine",
		children: [
			/* @__PURE__ */ _jsx("path", {
				id: "Vector",
				d: "M10.5 23.625H5.25C5.01794 23.625 4.79538 23.5328 4.63128 23.3687C4.46719 23.2046 4.375 22.9821 4.375 22.75V17.862C4.37511 17.6303 4.46715 17.408 4.63094 17.2441L18.1191 3.75596C18.2831 3.59199 18.5056 3.49988 18.7376 3.49988C18.9695 3.49988 19.192 3.59199 19.3561 3.75596L24.2441 8.64064C24.408 8.80472 24.5001 9.02719 24.5001 9.25916C24.5001 9.49112 24.408 9.7136 24.2441 9.87767L10.5 23.625Z",
				stroke: "current",
				strokeWidth: 2,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Vector_2",
				d: "M23.625 23.625H10.5",
				stroke: "current",
				strokeWidth: 2,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Vector_3",
				d: "M14.875 7L21 13.125",
				stroke: "current",
				strokeWidth: 2,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			})
		]
	})
});
export default SvgEdit;
